require('./creditCardOfferInfoModal.scss');
require('./creditCardOfferInfoModal.override.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const Modal = require('react-bootstrap/lib/Modal');
// @ constants
const modalBuyIcon = require('assets/icons/open-credit-modal-icon-buy.svg');
const modalDiscountIcon = require('assets/icons/open-credit-modal-icon-discount.svg');
const modalInsuranceIcon = require('assets/icons/open-credit-modal-icon-insurance.svg');
const modalPaymentIcon = require('assets/icons/open-credit-modal-icon-payment.svg');
// @ utilities
import { FormattedText } from 'core/i18n';
//@Icons
const closeIcon = require('assets/icons/close.svg');
const modalImg = require('assets/icons/modal-open-credit-2.png');

const CreditCardOfferInfoModal = ({ show, onClose, onHide }) => {
    return (
        <Modal
            bsSize="lg"
            className="credit-card-offer-info-modal-override"
            dialogClassName="credit-card-offer-info-modal"
            show={show}
            onHide={onHide}
        >
            <Modal.Header>
                <div className="credit-card-offer-info-modal__close-icon-img">
                    <a href="#" onClick={onClose}>
                        <img src={closeIcon} alt="" />
                    </a>
                </div>
                <img src={modalImg} className="modal-image" />
                <div className="credit-card-offer-info-modal__title">
                    <h5>
                        <FormattedText value="creditCardOffer-infoModalTitle" />
                    </h5>
                </div>
                <div className="credit-card-offer-info-modal__close-icon">
                    <a href="#" onClick={onClose}>
                        <img height="30" width="30" src={closeIcon} alt="" />
                    </a>
                </div>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-sm-3 col-xs-12 credit-card-offer-info-modal__icon-content">
                        <img className="credit-card-offer-info-modal__icon customSize" src={modalBuyIcon} alt="" />
                        <FormattedText value="creditCardOffer-infoModalBuyIconLabel" />
                    </div>
                    <div className="col-sm-3 col-xs-12 credit-card-offer-info-modal__icon-content">
                        <img className="credit-card-offer-info-modal__icon customSize" src={modalDiscountIcon} alt="" />
                        <FormattedText value="creditCardOffer-infoModalDiscountIconLabel" />
                    </div>
                    <div className="col-sm-3 col-xs-12 credit-card-offer-info-modal__icon-content">
                        <img
                            className="credit-card-offer-info-modal__icon customSize"
                            src={modalInsuranceIcon}
                            alt=""
                        />
                        <FormattedText value="creditCardOffer-infoModalInsuranceIconLabel" />
                    </div>
                    <div className="col-sm-3 col-xs-12 credit-card-offer-info-modal__icon-content">
                        <img className="credit-card-offer-info-modal__icon customSize" src={modalPaymentIcon} alt="" />
                        <FormattedText value="creditCardOffer-infoModalPaymentIconLabel" />
                    </div>
                </div>
                <br />
            </Modal.Body>
        </Modal>
    );
};

CreditCardOfferInfoModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

module.exports = CreditCardOfferInfoModal;
